import React from 'react'
import styled from 'styled-components'
import { motion, AnimatePresence } from 'framer-motion';
const Aboutme = () => {
  return (
    <Wrapper>
      <div className="section-heading">
        <p>About Me.</p>
      </div>
      <div className="intro">
        <AnimatePresence exitBeforeEnter>
          <motion.p
            key="intro-text"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: 20 }}
            transition={{ duration: 0.5 }}
            className='ptext'
          >
            Hello, I’m Hulesh!
            <br />
            <br />
            I’m a self-taught front-end developer based in Raipur, India. I can develop responsive websites from scratch
            and raise them into modern user-friendly web experiences.
            <br />
            <br />
            Transforming my creativity and knowledge into websites has been my passion for over a year. I have been
            helping various clients establish their presence online. I always strive to learn about the newest
            technologies and frameworks.
          </motion.p>
        </AnimatePresence>
        <div className="heroimg">
          <img src="./images/me.png" alt="" />
          <div className="blury"></div>
          <p className="working">
            <span className="green">.</span> Currently working on <span>Portfolio</span>
          </p>
        </div>
      </div>
      <div className="btn">
        <a className="btns" href="./resume.pdf" target="-blank">
          Resume <img src="./images/icons/download.png" alt="" />
        </a>
        <a className="btns" href="/contact">
          Hire Me <img src="./images/icons/user.png" alt="" />
        </a>
      </div>
      <div className="skill">
        <p className="skillname">Html5</p>
        <p className="skillname">Css3</p>
        <p className="skillname">Javascript</p>
        <p className="skillname">ReactJs</p>
        <p className="skillname">NodeJs</p>
        <p className="skillname">Mysql</p>
      </div>
    </Wrapper>
  )
}
const Wrapper = styled.div`
width: 100%;
height: 90vh;
    display: flex;
 flex-direction: column;
 /* justify-items: center; */
 /* align-items: center; */
color: white;
 gap: 10px; 
 
 .btn{
  margin-top: 20px;
  display: flex;
   flex-direction: row;
   gap: 10px;
   align-items: center;
   justify-content: center;
 }
 .btns{
  display: flex;
  flex-direction: row;
   gap: 5px;
   align-items: center;
   justify-content: center;
     width: 40%;
     height: 40px;
    text-decoration: none;
color:#121629 ;
background-color:#cbebf2df ;
font-size: 1.2rem;
   padding :6px 12px ;
   font-weight: 500;
   border-radius: 10px;
   border:  1px solid #66bcf115;
   transition: all ease-in-out 0.3s;
   cursor: pointer;
   @media screen and (min-device-width: 768px)
and (max-device-width: 1024px) {
   font-size: 2rem;
   height: fit-content;

   
      }
   :hover{
    color:#cbebf2df ;
background-color:#121629  ;
   }
  
   img{
    width: 20px;
    height: 20px;
 @media screen and (min-device-width: 768px)
and (max-device-width: 1024px) {
   
  width: 35px;
    height: 35px;
   
      }
   } 
 }
 .section-heading{
  margin: 0 auto;
 
 }
 .section-heading p{

  margin: 0 auto;
    font-family: 'Berkshire Swash', cursive;
    font-size: 2rem;
    margin-bottom: 25px;
    color: #6a6a7e;
    color:#FB315A;
    @media screen and (min-device-width: 768px)
and (max-device-width: 1024px) {
   font-size: 4rem;
   
      }
    @media (max-width: 480px) {
      font-size: 2rem;
        }
 }
 .intro 
 {
  .ptext{
    padding-top: 30px;
  }
    background-color: #66bcf115;
    padding: 20px 40px;
    backdrop-filter: blur(25px);
    width: 100%;
    font-size: 1rem;
    color: #8f9299;
    border-radius: 30px;
    display: flex;
    justify-content: space-between;
    justify-items: center;
 align-items: center;
 @media screen and (min-device-width: 768px)
and (max-device-width: 1024px) {
  flex-direction: column;
     padding: 0 10px;
      } 
 @media (max-width: 480px) {
     flex-direction: column;
     padding: 0 10px;
    }
 p{ padding-top: 20px;
    font-size: 1rem;
    font-family: 'Fira Code', monospace;
    letter-spacing: 1px;
    width: 60%;
    line-height: 20px;
    color: #838b99;
    font-weight: 200;
    @media screen and (min-device-width: 768px)
and (max-device-width: 1024px) {
   font-size: 1.7rem;
   width: 100%;
   padding: 0 15px;
   line-height: 40px;
      }
    @media (max-width: 480px) {
   width: 100%;
   padding: 0 15px;
   font-size: 1.2rem;
   line-height: 30px;
 }
}
 .heroimg{
    position: relative;
    
    .blury{
        position: absolute;
        top: 0;
        z-index: -2;
        width: 200px;
        height: 300px;
        border-radius: 50%;
        background-color: #0833b5;
        filter: blur(100px);
     
    }
    .working{
    position: absolute;
    bottom: 15px;
    left: -45%;
    width: fit-content;
    font-size: 1rem;
    font-weight: 200;
    background-color: #000000d0;
    padding: 10px 10px;
    border-radius: 20px;
    z-index: -1;
    @media screen and (min-device-width: 768px)
and (max-device-width: 1024px) {
   font-size: 1.5rem;
   left: -35%;
      }
    
    @media (max-width: 480px) {
    display: none;
        }
    .green{
        position: relative;
        z-index: 2;
        font-size: 1rem;
        color: #034a18;
        background-color: #0fce48;
        height: 10px;
    }
 }
 }
 img{
   opacity: 90%;
   transform: rotate(4deg);
   width: 350px;
   @media screen and (min-device-width: 768px)
and (max-device-width: 1024px) {
  margin: 25px 0;
     width: 500px;
      }
   @media (max-width: 480px) {
    margin: 25px 0;
      width: 100%;
        }
 }
 
}
.skill{
  display: flex;
  width: 100%;
  gap: 15px;
  text-align: center;
margin: 20px 0;
  justify-content: center;
  @media screen and (min-device-width: 768px)
and (max-device-width: 1024px) {
 
  display: flex;
      flex-wrap: wrap;
      }
  @media (max-width: 480px) {
      display: flex;
      flex-wrap: wrap;
        }
  p.skillname{
    display: flex;
    justify-content: center;
    align-items: center;
    font-family: 'Fira Code', monospace;
   font-size: 1.2rem;
   font-weight: 400;
   /* background-color: #fb3159; */
   width: 150px;
   height: 40px;
   padding: 0 25px;
   border-radius: 15px;
   border: 1px solid #cbebf2df;
   color: #838b99;
   transition: all ease-in-out 0.2s;
   cursor: pointer;
   @media screen and (min-device-width: 768px)
and (max-device-width: 1024px) {
  height: fit-content;
  padding: 10px 25px;
 width: fit-content;
  font-size: 2rem;
      }
   :hover{
    color:#121629 ;
background-color: #cbebf2df  ;
   }
  
  
  }

 
}
@media screen and (min-device-width: 768px)
and (max-device-width: 1024px) {
 
  height: 100%;
      }

@media (max-width: 480px) {
      font-size: 1.5rem;
      height: fit-content;
        }
`
export default Aboutme